import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';
import { Uuid } from '~/types/Uuid';

type Request = {
  contractRecordUniqueId?: string;
  wssContractId?: Uuid;
  trackOriginal?: boolean;
  asOfDate?: string;
};

type Response = {
  document_id: PilotId;
};
export async function resolveWssDocument({
  asOfDate,
  trackOriginal,
  contractRecordUniqueId,
  wssContractId,
}: Request): Promise<{ documentId: PilotId }> {
  const response: Response = await pilot.get(`/document/resolve-document-id/`, {
    params: {
      contract_record_unique_id: contractRecordUniqueId,
      wss_contract_id: wssContractId,
      as_of_date: asOfDate,
      track_original: trackOriginal,
    },
  });

  return {
    documentId: response.document_id,
  };
}
